// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8939d3c1","453":"286ba7e9","732":"907e2388","977":"071526ce"}[chunkId] + ".chunk.js";
};